import React from 'react';
export function ProductPresentation() {
  return <section className="w-full bg-transparent py-16 pt-[0px] pb-[0px]" data-id="element-230">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-231">
        <div className="text-center mb-6" data-id="element-232">
          <p className="text-[#F5D060] text-xs mb-1 font-[700] font-['Open_Sans',_sans-serif] border border-[#F5D060]/60 rounded-full px-4 py-1 inline-block bg-[#F5D060]/10 shadow-[0_0_12px_rgba(245,208,96,0.3)]" data-id="element-233">
            🏆✨ El Sistema N°1 en Material Psicopedagógico 🧠📚
          </p>
          <h1 className="md:text-5xl font-bold mb-6 font-['Open_Sans',_sans-serif] text-[#D4A843] text-[20px]" data-id="element-234">
            🧩MEGAPACK PSICOPEDAGOGÍA LISTA
            <sup className="text-[10px] align-super" data-id="element-235">TM</sup>
          </h1>
        </div>
      </div>
    </section>;
}